import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/store';
import { cityActions } from '@/reducers/cityConfig'
import './index.scss'
import { useNavigate } from "react-router-dom";
import { Space, Grid, Empty, Toast , Mask} from 'antd-mobile';
import apis from '@/api'
import { handleIosKeyboard } from '@/utils'
let hidden, visibilityChange:string;
if (typeof document.hidden !== "undefined") {
  // Opera 12.10 and Firefox 18 and later support
  hidden = "hidden";
  visibilityChange = "visibilitychange";
}
const Index = () => {

  const {
    cityData,locationCity
  } = useSelector((state: RootState) => state.cityConfig);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [loadingVisible, setLoadingVisible] = useState(false);
  const [backTop, setBackTop] = useState(false);
  const [shopList, setShopList] = useState([]);
  const [seachShopList, setSeachShopList] = useState([]);
  const [seachName, setSeachName] = useState('');
  const [telList, setTelList] = useState([]);
  let Tmap:any = {};
  const innerHeight = window.innerHeight;
  //跳转腾讯地图
  const mapJump = (x: number, y: number) => {
    window.open("https://apis.map.qq.com/uri/v1/geocoder?coord=" + x + "," + y + "&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77",'_self')

  }
  // 跳转城市列表
  const jumpCity = () => {
    navigate('/city')
    // const u = navigator.userAgent;
    // const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    // if(isAndroid)window.location.reload();

  }
  //回到顶部超过一屏显示
  const handleScroll = () => {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop + (innerHeight - 200) > innerHeight) {//超过一屏
      setBackTop(true)
    } else {
      setBackTop(false)
    }
  }
  //回到顶部
  const getBackTop = () => {
    window.scrollTo(0, 0)
  }
  //搜索
  const seachFiltration = () => {
    const shopData = shopList.filter(function (e: any) {
      return e.storeBasic.storeName.indexOf(seachName) != -1;
    });
    setSeachShopList(shopData)
  }
  const inputKeyUp = (e: any) => {
    console.log(e.keyCode);
    if (e.keyCode === 13) {
      seachFiltration();
      const input: any = document.getElementById("seachNameInput");
      input.blur();
    }
  }
  //拨打电话
  const handleTelPop = (storeTelephone: string) => {
    const telList: any = storeTelephone.split(',');
    if (telList.length > 0) {
      setTelList(telList);
      setVisible(true);
    } else {
      Toast.show({
        content: '暂无联系方式',
        afterClose: () => {
          console.log('after')
        },
      })
    }

  }
  //获取门店列表
  const getShopList = async (nowCity:any) => {
    try{
      const params = {
        cityId: (nowCity?nowCity.cityId:null)||cityData.cityId||'110100',
        x: Tmap.lng ? Tmap.lng : '116.466485',//纬度
        y: Tmap.lng ? Tmap.lat : '39.995197',//经度
        "storeId": "110411"
      };
      const res: any = await apis.getShopList(params);
      setLoadingVisible(false)
      if (res) {
        setShopList(res)
        setSeachShopList(res)
        setSeachName('')
      }
    }catch(error){
      setLoadingVisible(false)
    }

  }
  //获取城市列表
  const getCityList = async () => {
    const params = {
      "storeId": "110411"
    }
    const res: any = await apis.getCityList(params);
    if (res) {
      const citListAll: any = [];
      res.groupCityList.map((item: any) => {
        item[Object.keys(item)[0]].map((jtem: any) => {
          citListAll.push(jtem)
        })
      })
      let nowCity = null;
      //当前定位
      if(locationCity.cityId==cityData.cityId){
        citListAll.map((item: any) => {
          let cityName = item.city + "市"
          if (Tmap && cityName.indexOf(Tmap.city) != -1) {
            nowCity = item;
            dispatch(cityActions.setCity({
              cityId: item.cityId,
              cityName: item.city
            }));
            dispatch(cityActions.setLocationCity({
              cityId: item.cityId,
              cityName: item.city
            }));
          }
        })
      }else{
        nowCity = null;
      }
      getShopList(nowCity);
    }
  }
  const getLoca =  ()=>{
    console.log('进来了')
    new Promise((resolve,reject)=>{
      var geolocation =  new window.qq.maps.Geolocation('N3RBZ-H4BC5-SN4I5-QMRSL-ZAVA7-EIBN5', 'myapp');
      geolocation.getLocation((posi: any) => {
        console.log("当前位置1",posi)
        if (posi && posi.lng) {
          Tmap = posi ;
          console.log(Tmap)
        }
        resolve({})
      })
      setTimeout(()=>{
        reject({})
      },5000)

    }).then(()=>{
      getCityList();
    }).catch(()=>{
      getCityList();
    })
  }
  const pageShow = () => {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (!document.hidden&&isiOS) {
      // window.location.reload()
      window.WeixinJSBridge && window.WeixinJSBridge.call('hideOptionMenu');

    }
  }
  //页面初始化
  useEffect(() => {
    document.getElementsByTagName("title")[0].innerText = '捞派新年 快乐连连';
    window.document.addEventListener(visibilityChange, pageShow, false);
    window.addEventListener('scroll', handleScroll);
    setLoadingVisible(true);
    getLoca();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('visibilityChange', pageShow);
    }
  }, [])

  return (
    <div className={`index ${visible ? 'pop_ndex' : ''}`}>
      {/* banner图 */}

      <aside className="banner">
        <img alt="" className="banner__img" src={require('@/images/2026/banner.jpeg')} />
      </aside>
      {/* 主体 */}
      <main className="main">

        <div className="main__content">
          {/* 主体头部 */}
          <Space className="content_tit">
            <img alt="" className="content_glim" src={require('@/images/2026/glim_left.png')} />
            <img alt="" className="content_main_header" src={require('@/images/2026/main_header.png')} />
            <img alt="" className="content_glim" src={require('@/images/2026/glim_right.png')} />
          </Space>
          {/* 搜索 */}
          <div className="content__search">
            <div className="search__city" onClick={jumpCity}>
              <p>{cityData.cityName || '北京'}</p>
              <img alt="" className="search__city__icon" src={require('@/images/pull_down_icon.png')} />
            </div>
            <div className="search__input__box">
              <img alt="" src={require('@/images/search_icon.png')} />
              <form action="javascript:return true" className="search__form">
                <input id="seachNameInput" type="search" value={seachName} maxLength={20} className="search__input" placeholder="搜索门店" onBlur={handleIosKeyboard} onKeyUp={inputKeyUp} onChange={(val: any) => { setSeachName(val.target.value) }} />
              </form>
              <p className="search__btn" onClick={seachFiltration}>
                搜索
              </p>
            </div>
          </div>
          {/* 门店列表 */}
          {
            !loadingVisible?
            <div className="content__list">
              {seachShopList.length > 0 ?
                <>
                  {seachShopList.map((group: any, idx) => {
                    const { storeName, storeAddress, latitude, longitude, storeTelephone } = group.storeBasic;
                    const { distance, newYearsEve, springFestival, id, storeId } = group;
                    return (<div className="content__list_shop" key={idx + id + storeId}>
                      <Grid columns={4} gap={3}>
                        {/* 门店logo */}
                        <Grid.Item>
                          <img alt="" className="shop__img" src={require('@/images/shop_img.png')} />
                        </Grid.Item>
                        {/* 门店地址等 */}
                        <Grid.Item span={3} >
                          <div className="shop__tit">
                            <div className="shop__name">{storeName}</div>
                            <div className="shop__distance">{distance > 1000 ? ((distance / 1000).toFixed(2) + 'km') : Math.floor(distance) + 'm'}</div>
                          </div>
                          <div className="shop__address" onClick={() => { mapJump(latitude, longitude) }}>
                            <div className="shop__address__txt">{storeAddress}</div>
                            <div className="shop__address__right"><img alt="" src={require('@/images/right_icon.png')} /></div>
                          </div>
                          <div className="shop__division"></div>
                          <div className="shop__business">
                            <div>
                              <div className="shop__business__time">
                                除夕
                                <span className="business__time">{newYearsEve}</span>
                              </div>
                              <div className="shop__business__time">
                                初一
                                <span className="business__time">{springFestival}</span>
                              </div>
                            </div>
                            <div className="shop__business__tel" onClick={() => { handleTelPop(storeTelephone) }}>
                              <img alt="" src={require('@/images/2026/call_icon.png')} />
                              <p>电话</p>
                            </div>
                          </div>
                        </Grid.Item>
                      </Grid>
                    </div>
                    )

                  })}
                  <div className="content__list__nomore">
                    <div className="nomore__line"></div>
                    <div className="nomore__txt">没有更多了</div>
                    <div className="nomore__line"></div>
                  </div>
                </>
                : <Empty className="empty"
                  style={{ padding: '64px 0' }}
                  image={require('@/images/empty_2.png')}
                  description='没有搜索结果'
                />
              }

            </div>
            :null
          }
        </div>
      </main>
      {/* 电话弹窗 */}
      <Mask
        visible={visible}
        onMaskClick={() => setVisible(false)}
      >
        <div className="call__content">
          <div className="call__content__tit">请选择您要拨打的电话</div>
          {
            telList.map((group: string, idx) => {
              return <div className="call__content__tel" key={idx + group} onClick={() => window.location.href = 'tel:' + group}>{group}</div>
            })
          }
        </div>
      </Mask>
      {/* 回到顶部 */}
      {
        backTop
          ? <div className="back__top" onClick={getBackTop}>
            <img alt="" src={require('@/images/2026/back_top_icon.png')} />
          </div>
          : null
      }

      <Mask className="load__pop"
        visible={loadingVisible}
      >
        <div className="load__div">
            <img alt="" src={require('@/images/loading.gif')}/>
            <p>正在查询</p>
        </div>
      </Mask>
    </div>

  )
}

export default Index;
